import { getFormattedDate } from '@finn/platform-modules';
import dayjs from 'dayjs';
import React from 'react';

import { Review } from '~/types/reviews';

import Star from './Star';

interface IProps {
  className?: string;
  review: Review;
}

const UserReview: React.FunctionComponent<IProps> = ({ review }) => {
  return (
    <div className="w-64 md:w-96">
      <Star
        score={review.score}
        size="medium"
        color="#00B67A" // Official Trustpilot brand green
      />
      <p className="mt-6 h-32 w-full overflow-auto body-16-light">
        {review.comment}
      </p>
      <h3 className="mt-4 global-t6-semibold">{review.full_name}</h3>
      <p className="mb-4 mt-3 body-16-regular">
        {getFormattedDate(dayjs(review.create_date * 1000), 'DD. MMMM')}
      </p>
    </div>
  );
};

export default UserReview;
